var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"down_icon",on:{"click":_vm.handleClick}},[_c('img',{staticClass:"max-icon",attrs:{"src":require("@/assets/svg/down-max-ccc2.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }